/*
 * add by tht 2017-10-23
 * for forum forumInfo function dongchunshui
 */
(function () {
  //个人主页-获取消息列表
  var messageList = "/user/message/list";

  //回复评论，回复回贴
  var commentInfo = "/forum/comment/info";

  //回复主贴，给回帖点赞
  var postInfo = "/forum/post/info";
  //主贴信息
  var ofThread = "/forum/thread/info/ofThread";
  //6级等级道具信息
  var giftInfo = "/wealth/gift/info";

  //按类型获取和更新玩家消息设置状态
  var setting = "/user/message/chat/setting"; //get post

  // 获取私信唯独消息数
  const chatUnread = "/user/message/chat/unread";
  var giftIcon = "";
  //按类型获取和更新玩家消息未读状态
  var readMessage = "/user/message/read"; //get post
  var reportPopHtml =
    '<div class="reportPop">' +
    '<div class="reportMain">' +
    "<h3>请选择举报原因</h3>" +
    '<p class="flradio "><input type="radio" name="report" value="PornographicVulgarity">色情低俗</p>' +
    '<p class="flradio"><input type="radio" name="report" value="AdvertisingHarassment">广告骚扰</p>' +
    '<p class="flradio"><input type="radio" name="report" value="PoliticalSensitivities">政治敏感</p>' +
    '<p class="flradio"><input type="radio" name="report" value="Swindle">诈骗</p>' +
    '<p class="blockPop"><input type="radio" name="report" value="IllegalityHarmful">违法有害</p>' +
    '<p class="blockPop"><input type="radio" name="report" value="OtherReasons">其他原因</p>' +
    '<textarea rows="3" cols="20"  style="resize:none" class="otherReasons" maxlength="50"></textarea>' +
    '<p class="erroeWordRed"></p>' +
    '<div class="operationBox">' +
    '<a href="javascript:;" class="confirmBtn_pop">确认</a>' +
    '<a href="javascript:;" class="cancelBtn_pop">取消</a>' +
    "</div>" +
    "</div>" +
    '<a href="javascript:;" class="close_reportPop"></a>' +
    "</div>";
  function DaoMessageUser() {
    //操作
  }

  DaoMessageUser.prototype = {
    init: function () {
      var _this = this;
      _this.XtmessList(); //系统消息列表
      _this.getReplyFun(); //收到的回复列表
      _this.getGoodsFun(); //获得物品通知列表
      _this.mesSetClickFun(); //消息权限设置
      _this.myletterFun(); //我的私信
      _this.blacklistFun(); //我的黑名单
      // _this.handMsg()//私信手动红点；

      /*未读消息个数提示*/
      _this.noReadNum($(".xtNotice"), "system", "get");
      _this.noReadNum($(".replyList"), "replyMe", "get");
      _this.noReadNum($(".goodsList"), "receiveGoods", "get");
      _this.noReadNum($(".private"), "privateLetter", "get");

      //获取地址栏参数
      var typecode = global_main.globalFn.getLinkParamFn("type");
      if (typecode == "replyList") {
        $(".replyList").click(); //回复我的信息展示
      } else if (typecode == "goodsList") {
        $(".goodsList").click(); //礼物通知信息展示
      } else if (typecode == "private") {
        $(".private").click(); //我的私信展示
      } else {
        $(".xtNotice").click(); //系统通知信息展示
      }

      if ($(".reportPop").length == 0) {
        $("body").append(reportPopHtml);
      }
      $(".private").append(
        '<span class="headRed" style="display: none;" data-num=0></span>'
      );
      _this.chatUnreadFn();
    },

    chatUnreadFn: function () {
      $.ajax({
        type: "get",
        url: chatUnread,
        data: {
          r: Math.random(),
        },
        dataType: "json",
        success: function (d) {
          if (d.status == "success" && d.data) {
            $(".headRed").html(d.data);
            $(".headRed").attr("data-num", d.data);
            $(".headRed").show();
          } else {
            $(".headRed").html('');
            $(".headRed").attr("data-num", 0);
            $(".headRed").hide();
          }
        },
      });
    },
    //手动私信红点
    handMsg: function () {
      var cookieVal = document.cookie.split(";");
      if (cookieVal.indexOf(" redType=true") !== -1) {
        if (!$(".headRed").attr("class")) {
          $(".private").append(
            '<span class="headRed" style="display:block"></span>'
          );
        } else {
          $(".headRed").show();
        }
      } else {
        $(".headRed").hide();
      }
    },
    //消息未读增加小红点提示（个数）
    noReadNum: function (obj, typeString, typeAjax) {
      $.ajax({
        type: typeAjax,
        url: readMessage,
        data: {
          r: Math.random(),
          type: typeString,
        },
        dataType: "json",
        success: function (d) {
          if (typeAjax == "get") {
            if (d.status == "success") {
              obj.find(".iconRed").html(d.data > 99 ? "99+" : d.data);
              obj.find(".iconRed").attr("data-num", d.data);
              obj.find(".iconRed").css("display", "block");
            } else {
              obj.find(".iconRed").css("display", "none");
            }
          } else {
            if (d.status == "success") {
              obj.find(".iconRed").css("display", "none");
            }
            global_main.globalFn.unread();
          }
        },
        error: function () {
          $(document).popErrorF({
            type: "open",
            tip: "程序小哥打盹儿了，刷新页面试试！",
          });
        },
      });
    },

    //点击高亮展示
    lightClickFun: function (thisObjct) {
      var tihsObj = thisObjct;
      $(".messType li").removeClass("cur");
      tihsObj.addClass("cur");
      $(".listMeun,#wl_faces_box").hide();
    },

    //点击系统消息处理事件
    XtmessList: function () {
      var _this = this;
      $(".xtNotice").click(function () {
        $(".historyMsgBox").hide();
        //请求接口获取数据
        $.ajax({
          type: "get",
          url: "/user/login/status",
          data: {
            r: Math.random(),
          },
          success: function (d) {
            if (d.status == "success") {
              var systemId = "system";
              $(".js_messSet,.js_blackList,.js_privateBox").hide();
              _this.noReadNum($(".xtNotice"), "system", "post"); //已读消息
              $(".NoticeContent h3").html("系统消息");
              _this.lightClickFun($(".xtNotice"));
              _this.messageList(systemId);
              $(".NoticeContent,.pageCut").show();
              const num = $(".xtNotice .iconRed").attr("data-num")
                ? Number($(".xtNotice .iconRed").attr("data-num"))
                : 0;
              const notReadNum = $(".notRead").attr("data-num")
                ? Number($(".notRead").attr("data-num"))
                : 0;
              $(".notRead").html(
                notReadNum - num > 99 ? "99+" : notReadNum - num
              );
              $(".notRead").attr("data-num", notReadNum - num);
              if (notReadNum - num <= 0) {
                $(".notRead").hide();
              }
              // global_main.globalFn.unread();
            } else {
              $(document).errorDataOperateFn(d);
            }
          },
          error: function () {
            $(document).popErrorF({
              type: "open",
              tip: "程序小哥打盹儿了，刷新页面试试！",
            });
          },
        });
      });
    },
    //点击收到的回复
    getReplyFun: function () {
      var _this = this;
      $(".replyList").click(function () {
        $(".historyMsgBox").hide();
        //请求接口获取数据
        $.ajax({
          type: "get",
          url: "/user/login/status",
          data: {
            r: Math.random(),
          },
          success: function (d) {
            if (d.status == "success") {
              var replyMeId = "replyMe";
              $(".js_messSet,.js_blackList,.js_privateBox").hide();
              _this.noReadNum($(".replyList"), "replyMe", "post"); //已读消息
              $(".NoticeContent h3").html("收到的回复");
              _this.lightClickFun($(".replyList"));
              _this.messageList(replyMeId);
              $(".NoticeContent,.pageCut").show();
              const num = $(".replyList .iconRed").attr("data-num")
                ? Number($(".replyList .iconRed").attr("data-num"))
                : 0;
              const notReadNum = $(".notRead").attr("data-num")
                ? Number($(".notRead").attr("data-num"))
                : 0;
              console.log(notReadNum - num, notReadNum, num);
              $(".notRead").html(
                notReadNum - num > 99 ? "99+" : notReadNum - num
              );
              $(".notRead").attr("data-num", notReadNum - num);
              if (notReadNum - num <= 0) {
                $(".notRead").hide();
              }
              // global_main.globalFn.unread();
            } else {
              $(document).errorDataOperateFn(d);
            }
          },
          error: function () {
            $(document).popErrorF({
              type: "open",
              tip: "程序小哥打盹儿了，刷新页面试试！",
            });
          },
        });
      });
    },
    //点击获得物品通知
    getGoodsFun: function () {
      var _this = this;
      $(".goodsList").click(function () {
        $(".historyMsgBox").hide();
        //请求接口获取数据
        $.ajax({
          type: "get",
          url: "/user/login/status",
          data: {
            r: Math.random(),
          },
          success: function (d) {
            if (d.status == "success") {
              var receiveGoodsId = "receiveGoods";
              $(".js_messSet,.js_blackList,.js_privateBox").hide();
              _this.noReadNum($(".goodsList"), "receiveGoods", "post"); //已读消息
              $(".NoticeContent h3").html("获得物品通知");
              _this.lightClickFun($(".goodsList"));
              _this.messageList(receiveGoodsId);
              $(".NoticeContent,.pageCut").show();
              const num = $(".goodsList .iconRed").attr("data-num")
                ? Number($(".goodsList .iconRed").attr("data-num"))
                : 0;
              const notReadNum = $(".notRead").attr("data-num")
                ? Number($(".notRead").attr("data-num"))
                : 0;
              $(".notRead").html(
                notReadNum - num > 99 ? "99+" : notReadNum - num
              );
              $(".notRead").attr("data-num", notReadNum - num);
              if (notReadNum - num <= 0) {
                $(".notRead").hide();
              }
              // global_main.globalFn.unread();
            } else {
              $(document).errorDataOperateFn(d);
            }
          },
          error: function () {
            $(document).popErrorF({
              type: "open",
              tip: "程序小哥打盹儿了，刷新页面试试！",
            });
          },
        });
      });
    },
    //点击我的私信
    myletterFun: function () {
      var _this = this;
      $(".private").click(function () {
        $(".js_messSet,.js_blackList,.NoticeContent,.pageCut").hide();
        $(".js_privateBox").show();
        $(".msgflow").scrollTop($(".msgflow")[0]?.scrollHeight);
        $(".defaultsWord").remove();
        _this.lightClickFun($(this));
        $.ajax({
          type: "post",
          url: "/user/message/read",
          data: {
            r: Math.random(),
            type: "privateLetter",
          },
          dataType: "json",
          success: function (d) {},
          error: function () {},
        });
        $.ajax({
          type: "get",
          url: "/user/login/status",
          data: {
            r: Math.random(),
          },
          success: function (d) {
            if (d.status == "success") {
              const num = $('.sessinfo-sel').find('.badge').attr('data-num');
              const sixinNum = Number($('.headRed').attr('data-num'));
              if (window.socket && window.socket.readyState == 1) {
                socket.send(JSON.stringify({
                  msgType: 100,
                  appId: socketUserSign.appId,
                  version: socketUserSign.version,
                  userId: socketUserSign.userId,
                  receiveUserId: $('.sessinfo-sel').attr('attrid')
                }));
              }
              if (sixinNum - num <= 0) {
                $('.headRed').hide();
                $('.headRed').attr('data-num', 0)
               
              }else {
                $('.headRed').attr('data-num', sixinNum - num)
              }
              $('.sessinfo-sel').find('.badge').attr('data-num',0)
              $('.sessinfo-sel').find('.badge').html('');
              $('.sessinfo-sel').find('.badge').hide();
              $('.sessinfo-sel').find('.delChat').show();
              $(".private .iconRed").remove();
            } else {
              $(document).errorDataOperateFn(d);
            }
          },
          error: function () {
            $(document).popErrorF({
              type: "open",
              tip: "程序小哥打盹儿了，刷新页面试试！",
            });
          },
        });
      });
    },
    setingMessage: function () {
      //请求接口获取数据
      $.ajax({
        type: "GET",
        url: setting,
        data: {
          r: Math.random(),
        },
        dataType: "json",
        success: function (d) {
          if (d.status == "success") {
            var setName = d.data;
            if (setName == "ShieldAll") {
              //不接受全部消息
              //$("#webim_demo").hide();
              $(".disable_title").remove();
              $(".js_privateBox").prepend(
                "<p class='disable_title'>您设置了不接收全部消息，将无法收到非官方账号的回复，可前往消息设置打开~</p>"
              );
            } else {
              $("#webim_demo").show();
              $(".disable_title").remove();
            }
          } else {
            $(document).errorDataOperateFn(d);
            $(".sesslist,.msgflow,#send_msg_text").html(""); //清空会话框
          }
        },
        error: function () {
          $(document).popErrorF({
            type: "open",
            tip: "程序小哥打盹儿了，刷新页面试试！",
          });
        },
      });
    },
    //黑名单点击
    blacklistFun: function () {
      var _this = this;
      $(".blackList").click(function () {
        $(
          ".js_messSet,.js_blackList,.NoticeContent,.js_privateBox,.pageCut"
        ).hide();
        $(".js_blackList").show();
        _this.lightClickFun($(this));
        //请求接口获取数据
        $.ajax({
          type: "get",
          url: "/user/login/status",
          data: {
            r: Math.random(),
          },
          success: function (d) {
            if (d.status == "success") {
              //调用黑名单列表
              getBlackList();
              _this.lightClickFun($(".blackList"));
            } else {
              $(document).errorDataOperateFn(d);
              $(".black_listUl").html("");
            }
          },
          error: function () {
            $(".black_listUl").html("");
            $(document).popErrorF({
              type: "open",
              tip: "程序小哥打盹儿了，刷新页面试试！",
            });
          },
        });
      });
    },
    //点击消息设置处理事件
    mesSetClickFun: function () {
      var _this = this;
      $(".messageSet").click(function () {
        _this.lightClickFun($(".messageSet"));
        _this.messageSet();
      });
      $(".js_messSet .sel").click(function () {
        $(".js_messSet .sel").removeClass("active");
        $(this).addClass("active");
        _this.messageSeting($(this).attr("parm"));
      });
    },

    //消息设置（权限）设置
    messageSeting: function (shieldString) {
      //请求接口获取数据
      $.ajax({
        type: "POST",
        url: setting,
        data: {
          r: Math.random(),
          setting: shieldString,
        },
        dataType: "json",
        success: function (d) {
          if (d.status == "success") {
            //成功更新状态
          } else {
            $(document).errorDataOperateFn(d);
          }
        },
        error: function () {
          $(document).popErrorF({
            type: "open",
            tip: "程序小哥打盹儿了，刷新页面试试！",
          });
        },
      });
    },
    //消息设置（权限）获取
    messageSet: function () {
      $(".NoticeContent,.js_privateBox,.js_blackList,.pageCut").hide();
      $(".js_NoticeList,.paging_full_numbers").html("");
      $(".js_messSet").show();
      //请求接口获取数据
      $.ajax({
        type: "GET",
        url: setting,
        data: {
          r: Math.random(),
        },
        dataType: "json",
        success: function (d) {
          if (d.status == "success") {
            var setName = d.data;
            for (var i = 0; i < $(".js_messSet li").length; i++) {
              var selValue = $(".js_messSet li span").eq(i).attr("parm");
              if (setName == selValue) {
                $(".js_messSet li span").eq(i).addClass("active");
              }
            }
          } else {
            $(document).errorDataOperateFn(d);
          }
        },
        error: function () {
          $(document).popErrorF({
            type: "open",
            tip: "程序小哥打盹儿了，刷新页面试试！",
          });
        },
      });
    },

    //格式化html标签内容
    formatHtmlTagConFn: function (htmlStr, len) {
      //需要格式化的HTML-htmlStr 格式化后字符串长度-len
      //视频个数正则表达式
      var expVideo = new RegExp("(<EMBED|<embed)[^>]+(>|/>)", "g");
      //图片个数正则表达式
      var expImg = new RegExp("(<IMG|<img)[^>]+(>|/>)", "g");

      //字符截取长度
      var cutLen = len ? parseInt(len) : 31;

      var ImgsArr = htmlStr.match(expImg);
      var videosArr = htmlStr.match(expVideo);

      var formattedStr = "";
      var noHtmlTagStr = htmlStr
        .replace(/<\/?[^>]*>/g, "")
        .replace(/&nbsp;/gi, "");
      if (noHtmlTagStr.length) {
        formattedStr =
          noHtmlTagStr.length > cutLen
            ? noHtmlTagStr.substring(0, cutLen) + "..."
            : noHtmlTagStr;
      } else {
        if (ImgsArr || videosArr) {
          if (ImgsArr) {
            formattedStr += "[图片]";
          }
          if (videosArr) {
            formattedStr += "[视频]";
          }
        }
      }
      return formattedStr;
    },
    //获取评论信息内容接口
    getCommentInfo: function (dataD, typeStatus, _href) {
      var _this = this;
      var postId = typeof dataD == "string" ? dataD : dataD.contentId;
      var isPlotter =
        '<span class="ico_tie js_wealthsShow isPlotter"><span class="num js_marginLeft js_wealthNumTop" style="visibility: hidden; width: 60px; margin-left: -8px;">仅策划可见<i class="arrow"></i></span></span>';
      var isPlotterHtml = dataD.isPlotter ? isPlotter : "";
      var htmlLi = "";
      $.ajax({
        type: "GET",
        url: commentInfo,
        data: {
          r: Math.random(),
          commentId: postId,
        },
        dataType: "json",
        async: false,
        success: function (dsq) {
          if (typeStatus == 1) {
            if (dsq.data != null) {
              var ds = dsq.data;
              var isPostPlotterHtml = ds.isPlot ? isPlotter : "";
              //回复回帖
              if (dataD.type == "replyPost") {
                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  ds.postId +
                  '" >' +
                  '<a class="lf" target="_blank" href="/user?id=' +
                  dataD.fromId +
                  '">' +
                  '<span class="sourceNick js_checkEveryUserInfo" data-userinfoid="' +
                  dataD.fromId +
                  '">' +
                  dataD.fromNickname +
                  "</span>" +
                  "</a>" +
                  '<div class="con lf">' +
                  '<p class="infosC lf">' +
                  '<span class="actionTo">回复 :</span>' +
                  '<span class="tieInfo">' +
                  '<a class="commentLink" comment="' +
                  postId +
                  '" target="_blank" href="/forum/thread?id=' +
                  ds.threadId +
                  "#" +
                  ds.postId +
                  '">' +
                  _this.formatHtmlTagConFn(ds.content) +
                  "</a>" +
                  "</span>" +
                  isPlotterHtml +
                  "</p>";
                if (ds.toContent) {
                  htmlLi +=
                    '<p class="infosC infosHF lf">' +
                    '<span class="actionTo">在回帖</span><span class="tieInfo">' +
                    '<a target="_blank" class="postLink" href="/forum/thread?id=' +
                    ds.threadId +
                    "#" +
                    ds.postId +
                    '">' +
                    _this.formatHtmlTagConFn(ds.toContent) +
                    "</a>" +
                    isPostPlotterHtml +
                    "</span>" +
                    "</p>" +
                    "</div>";
                  htmlLi +=
                    '<div class="riCon lf">' +
                    '<p class="times lf"><span>' +
                    $(document).formatDate(dataD.createTime) +
                    "</span></p>" +
                    '<p class="show_report"><span class="acknowledge"></span></p>' +
                    "</div>" +
                    '<div style="clear: both;"></div>' +
                    "</li>";
                }
              }
              //回复评论
              if (dataD.type == "replyComment") {
                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  ds.postId +
                  '" >' +
                  '<a class="lf" target="_blank" href="/user?id=' +
                  dataD.fromId +
                  '">' +
                  '<span class="sourceNick js_checkEveryUserInfo" data-userinfoid="' +
                  dataD.fromId +
                  '">' +
                  dataD.fromNickname +
                  "</span>" +
                  "</a>" +
                  '<div class="con lf">' +
                  '<p class="infosC lf">' +
                  '<span class="actionTo">回复 :</span>' +
                  '<span class="tieInfo">' +
                  '<a target="_blank" comment="' +
                  postId +
                  '" class="commentLink" href="/forum/thread?id=' +
                  ds.threadId +
                  "#" +
                  ds.postId +
                  '">' +
                  _this.formatHtmlTagConFn(ds.content) +
                  "</a>" +
                  "</span>" +
                  "</p>";
                if (ds.toContent) {
                  htmlLi +=
                    '<p class="infosC infosHF lf">' +
                    '<span class="actionTo">在评论</span><span class="tieInfo">' +
                    '<a target="_blank" class="commentLink" comment="' +
                    ds.toContentId +
                    '" href="/forum/thread?id=' +
                    ds.threadId +
                    "#" +
                    ds.postId +
                    '">' +
                    _this.formatHtmlTagConFn(ds.toContent) +
                    "</a>" +
                    "</span>" +
                    isPostPlotterHtml +
                    "</p>" +
                    "</div>";
                  htmlLi +=
                    '<div class="riCon lf">' +
                    '<p class="times lf"><span>' +
                    $(document).formatDate(dataD.createTime) +
                    "</span></p>" +
                    '<p class="show_report"><span class="acknowledge"></span></p>' +
                    "</div>" +
                    '<div style="clear: both;"></div>' +
                    "</li>";
                }
              }
              //被点赞评论
              if (dataD.type == "praiseComment" && ds.content) {
                //赞了您的评论
                htmlLi +=
                  '<li class="handleForYouTie " content="' +
                  ds.postId +
                  '" >' +
                  '<div class="con lf">' +
                  '<p class="infosC lf">' +
                  '<a class="lf zanComment" target="_blank" href="/user?id=' +
                  dataD.fromId +
                  '">' +
                  '<span class="sourceNick js_checkEveryUserInfo" data-userinfoid="' +
                  dataD.fromId +
                  '">' +
                  dataD.fromNickname +
                  "</span>" +
                  "</a>" +
                  '<span class="actionTo">赞了您的评论</span>' +
                  '<span class="tieInfo">' +
                  '<a target="_blank" class="commentLink" href="/forum/thread?id=' +
                  ds.threadId +
                  "#" +
                  ds.postId +
                  '" comment="' +
                  postId +
                  '">' +
                  _this.formatHtmlTagConFn(ds.content) +
                  "</a>" +
                  "</span>" +
                  isPlotterHtml +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf"><span>' +
                  $(document).formatDate(dataD.createTime) +
                  "</span></p>" +
                  '<p class="show_report"><span class="acknowledge"></span></p>' +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
              //被隐藏评论
              if (dataD.type == "hideComment") {
                //主贴标题
                var forumTitle = ds.title;
                //评论在主贴字段加锁
                var commentIsPlotHtml = ds.isThreadPlot ? isPlotter : "";
                //回帖内容
                var commentCon = _this.formatHtmlTagConFn(ds.content);
                var cutCommentConTen =
                  commentCon.length > 10
                    ? commentCon.substring(0, 10) + "..."
                    : commentCon;
                var cutPostCommentTwenty =
                  commentCon.length > 20
                    ? commentCon.substring(0, 20) + "..."
                    : commentCon;
                //隐藏原因
                var hidReason = dataD.content;
                var cutHidReason =
                  hidReason.length > 10
                    ? hidReason.substring(0, 10) + "..."
                    : hidReason;

                var conStr =
                  '<span class="contentHidden">您的评论<a title="' +
                  cutPostCommentTwenty +
                  '" class="cont">"' +
                  cutCommentConTen +
                  '"</a>' +
                  '由于<a title="' +
                  hidReason +
                  '" class="cont">"' +
                  cutHidReason +
                  '"</a>' +
                  '已被删除，如有疑问请<a target="_blank" href="//kf.gyyx.cn/Home/IMIndex">联系客服</a>。</span>';
                var forumConStr =
                  '<span class="contentHidden">在主贴' +
                  '<a class="tit">' +
                  forumTitle +
                  "</a></span>" +
                  commentIsPlotHtml;

                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  dataD.contentId +
                  '">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  conStr +
                  "</p>" +
                  '<p class="infosC lf infosHF">' +
                  forumConStr +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
            }
          } else {
            if (dsq.status == "success") {
              window.open(_href);
            } else if (dsq.status == "suspend" || dsq.status == "ipsuspend") {
              //异常状态处理
              global_main.globalFn.callBackErrStatusOpreFn(dsq);
            } else {
              $(document).popErrorF({
                type: "open",
                tip: dsq.message,
              });
            }
          }
        },
      });
      return htmlLi;
    },
    //获取主帖信息
    getThreadInfo: function (dataD, typeStatus) {
      var threadId = typeof dataD == "string" ? dataD : dataD.contentId;
      var htmlLi = "";
      $.ajax({
        type: "GET",
        url: ofThread,
        data: {
          r: Math.random(),
          threadId: threadId,
        },
        dataType: "json",
        async: false,
        success: function (dszP) {
          if (typeStatus == 1) {
            if (dszP.data != null) {
              var dsz = dszP.data;
              var titleContent = dsz.title
                .replace(/<\/?[^>]*>/g, "")
                .replace(/&nbsp;/gi, ""); //标题
              if (dataD.type == "runlottery") {
                var titleLink =
                  '<a target="_blank" class="js_titleSize" href="/forum/thread?id=' +
                  threadId +
                  '">' +
                  dsz.title.replace(/<\/?[^>]*>/g, "").replace(/&nbsp;/gi, "") +
                  "</a>";
                var runConStr =
                  '<span class="contentHidden">您参与的竞猜' +
                  titleLink +
                  '&nbsp;已开奖，请前往<a class="linkePlotter" target="_blank" style="padding-left:0px;" href="#myQuiz">竞猜记录</a>查看吧，如有疑问请<a target="_blank" class="linkePlotter" href="//kf.gyyx.cn/Home/IMIndex">联系客服</a>。</span>';

                htmlLi +=
                  '<li class="handleForYouTie">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  runConStr +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              } else if (dataD.type == "stopQuiz") {
                //终止竞猜，消息列表展示内容
                //终止竞猜标题
                var titleContentSize =
                  titleContent.length > 10
                    ? titleContent.substring(0, 10) + "..."
                    : titleContent;
                var stopTitleLink =
                  '<a target="_blank" style="padding-left:5px;" href="/forum/thread?id=' +
                  threadId +
                  '">' +
                  titleContentSize +
                  "</a>";
                //终止竞猜原因
                var stopReason = dataD.content ? dataD.content : "";
                var cutHidReason =
                  stopReason.length > 10
                    ? stopReason.substring(0, 10) + "..."
                    : stopReason;
                var stopRunConStr =
                  '<span class="contentHidden">您参与的竞猜' +
                  stopTitleLink +
                  '&nbsp;由于<a title="' +
                  stopReason +
                  '" style="padding-left:5px;" class="cont">"' +
                  cutHidReason +
                  '"</a>' +
                  '&nbsp;已经被终止，看看<a target="_blank" style="padding-left:5px;" class="linkePlotter" href="/forum?isPc=true&targe=quiz">其他竞猜</a>&nbsp;吧~</span>';
                htmlLi +=
                  '<li class="handleForYouTie">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  stopRunConStr +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              } else if (dataD.type == "acceptAskHide") {
                //被采纳的回帖被删除或者仅策划可见
                //主贴标题
                var cutTitle =
                  titleContent.length > 10
                    ? titleContent.substring(0, 10) + "..."
                    : titleContent;

                var conStr =
                  '<span class="actionTo">您的提问</span>' +
                  '<span class="tieInfo"><a target="_blank" class="postLink" href="/forum/thread?id=' +
                  threadId +
                  '">' +
                  cutTitle +
                  "</a></span>" +
                  '<span class="actionTo">采纳回帖已被删除，请重新选择满意回答</span>';

                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  dataD.contentId +
                  '">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  conStr +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              } else if (dataD.type == "noticeAcceptAsk") {
                //求助帖超过24小时未采纳回帖
                //主贴标题
                var cutTitle1 =
                  titleContent.length > 10
                    ? titleContent.substring(0, 10) + "..."
                    : titleContent;

                var conStr1 =
                  '<span class="actionTo">您的提问</span>' +
                  '<span class="tieInfo"><a target="_blank" class="postLink" href="/forum/thread?id=' +
                  threadId +
                  '">' +
                  cutTitle1 +
                  "</a></span>" +
                  '<span class="actionTo">尚有未采纳回复，请及时处理</span>';

                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  dataD.contentId +
                  '">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  conStr1 +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
            }
          } else {
            if (dszP.status == "suspend" || dszP.status == "ipsuspend") {
              //异常状态处理
              global_main.globalFn.callBackErrStatusOpreFn(dszP);
            } else {
              $(document).popErrorF({
                type: "open",
                tip: dszP.message,
              });
            }
          }
        },
      });
      return htmlLi;
    },
    //获取回帖信息
    getPostInfo: function (dataD, typeStatus, _href) {
      var _this = this;
      var postId = typeof dataD == "string" ? dataD : dataD.contentId;
      var isPlotter =
        '<span class="ico_tie js_wealthsShow isPlotter"><span class="num js_marginLeft js_wealthNumTop" style="visibility: hidden; width: 60px; margin-left: -8px;">仅策划可见<i class="arrow"></i></span></span>';
      var isPlotterHtml = dataD.isPlotter ? isPlotter : "";
      var htmlLi = "";
      $.ajax({
        type: "GET",
        url: postInfo,
        data: {
          r: Math.random(),
          postId: postId,
        },
        dataType: "json",
        async: false,
        success: function (dszP) {
          if (typeStatus == 1) {
            if (dszP.data != null) {
              var dsz = dszP.data;
              var isPostPlotterHtml = dsz.isPlot ? isPlotter : "";
              //回复主贴
              if (dataD.type == "replyThread") {
                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  postId +
                  '">' +
                  '<a class="lf" target="_blank" href="/user?id=' +
                  dataD.fromId +
                  '">' +
                  '<span class="sourceNick js_checkEveryUserInfo" data-userinfoid="' +
                  dataD.fromId +
                  '">' +
                  dataD.fromNickname +
                  "</span>" +
                  "</a>" +
                  '<div class="con lf">' +
                  '<p class="infosC lf">' +
                  '<span class="actionTo">回复 :</span>' +
                  '<span class="tieInfo"><a target="_blank" class="postLink js_titleSize" href="/forum/thread?id=' +
                  dsz.threadId +
                  "#" +
                  postId +
                  '">' +
                  _this.formatHtmlTagConFn(dsz.content) +
                  "</a></span>" +
                  isPlotterHtml +
                  "</p>";
                if (dsz.title) {
                  htmlLi +=
                    '<p class="infosC infosHF lf">' +
                    '<span class="actionTo">在主贴</span><span class="tieInfo">' +
                    '<a target="_blank" class="js_titleSize" href="/forum/thread?id=' +
                    dsz.threadId +
                    '">' +
                    dsz.title
                      .replace(/<\/?[^>]*>/g, "")
                      .replace(/&nbsp;/gi, "") +
                    "</a>" +
                    "</span>" +
                    isPostPlotterHtml +
                    "</p>" +
                    "</div>";
                }
                htmlLi +=
                  '<div class="riCon lf">' +
                  '<p class="times lf"><span>' +
                  $(document).formatDate(dataD.createTime) +
                  "</span></p>" +
                  '<p class="show_report"><span class="acknowledge"></span></p>' +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
              //给回帖/主贴点赞
              if (dataD.type == "praisePost") {
                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  postId +
                  '">' +
                  '<div class="con lf"><p class="infosC lf">' +
                  '<a class="lf postLink" target="_blank" href="/user?id=' +
                  dataD.fromId +
                  '"><span class="sourceNick js_checkEveryUserInfo" data-userinfoid="' +
                  dataD.fromId +
                  '">' +
                  dataD.fromNickname +
                  "</span></a>" +
                  '<span class="actionTo">赞了您的回帖</span>' +
                  '<span class="tieInfo"><a target="_blank" class="postLink" href="/forum/thread?id=' +
                  dsz.threadId +
                  "#" +
                  postId +
                  '">' +
                  _this.formatHtmlTagConFn(dsz.content) +
                  "</a></span>" +
                  isPlotterHtml +
                  "</p></div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf"><span>' +
                  $(document).formatDate(dataD.createTime) +
                  "</span></p>" +
                  '<p class="show_report"><span class="acknowledge"></span></p>' +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
              if (dataD.type == "collectPost") {
                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  postId +
                  '">' +
                  '<div class="con lf"><p class="infosC lf">' +
                  '<a class="lf postLink" target="_blank" href="/user?id=' +
                  dataD.fromId +
                  '"><span class="sourceNick js_checkEveryUserInfo" data-userinfoid="' +
                  dataD.fromId +
                  '">' +
                  dataD.fromNickname +
                  "</span></a>";
                if (dataD.contentType === "thread") {
                  htmlLi +=
                    '<span class="actionTo">收藏了您的帖子</span>' +
                    '<span class="tieInfo"><a target="_blank" class="postLink" href="/forum/thread?id=' +
                    dsz.threadId +
                    "#" +
                    postId +
                    '">' +
                    _this.formatHtmlTagConFn(dsz.title) +
                    "</a></span>";
                } else {
                  htmlLi +=
                    '<span class="actionTo">收藏了您的回答</span>' +
                    '<span class="tieInfo"><a target="_blank" class="postLink" href="/forum/thread?id=' +
                    dsz.threadId +
                    "#" +
                    postId +
                    '">' +
                    _this.formatHtmlTagConFn(dsz.content) +
                    "</a></span>";
                }

                htmlLi +=
                  isPlotterHtml +
                  "</p></div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf"><span>' +
                  $(document).formatDate(dataD.createTime) +
                  "</span></p>" +
                  '<p class="show_report"><span class="acknowledge"></span></p>' +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
              //获取被隐藏回帖内容
              if (dataD.type == "hidePost") {
                //主贴标题
                var forumTitle = dsz.title;
                //回帖内容
                var postCon = _this.formatHtmlTagConFn(dsz.content);
                var cutPostConTen =
                  postCon.length > 10
                    ? postCon.substring(0, 10) + "..."
                    : postCon;
                var cutPostConTwenty =
                  postCon.length > 20
                    ? postCon.substring(0, 20) + "..."
                    : postCon;
                //隐藏原因
                var hidReason = dataD.content;
                var cutHidReason =
                  hidReason.length > 10
                    ? hidReason.substring(0, 10) + "..."
                    : hidReason;

                var conStr =
                  '<span class="contentHidden">您的回帖<a title="' +
                  cutPostConTwenty +
                  '" class="cont">"' +
                  cutPostConTen +
                  '"</a>' +
                  '由于<a title="' +
                  hidReason +
                  '" class="cont">"' +
                  cutHidReason +
                  '"</a>' +
                  '已被删除，如有疑问请<a target="_blank"  href="//kf.gyyx.cn/Home/IMIndex">联系客服</a>。</span>';
                var forumConStr =
                  '<span class="contentHidden">在主贴' +
                  '<a class="tit">' +
                  forumTitle +
                  "</a></span>";

                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  dataD.contentId +
                  '">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  conStr +
                  "</p>" +
                  '<p class="infosC lf infosHF">' +
                  forumConStr +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
              //求助主贴中被采纳回帖内容
              if (dataD.type == "acceptAsk") {
                //回帖内容
                var postCon1 = _this.formatHtmlTagConFn(dsz.content);

                var conStr1 =
                  '<span class="actionTo">您的回帖</span>' +
                  '<span class="tieInfo"><a target="_blank" class="postLink" href="/forum/thread?id=' +
                  dsz.threadId +
                  "#" +
                  postId +
                  '">' +
                  postCon1 +
                  "</a></span>" +
                  '<span class="actionTo">已被采纳</span>';

                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  dataD.contentId +
                  '">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  conStr1 +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
              //求助主贴中被采纳回帖内容，赠与好心值
              if (dataD.type == "acceptAskWithGW") {
                //回帖内容
                var postConHtml = _this.formatHtmlTagConFn(dsz.content);

                var conStrHtml =
                  '<span class="actionTo">您的回帖</span>' +
                  '<span class="tieInfo"><a target="_blank" class="postLink" href="/forum/thread?id=' +
                  dsz.threadId +
                  "#" +
                  postId +
                  '">' +
                  postConHtml +
                  "</a></span>" +
                  '<span class="actionTo">已被采纳，好心值+5</span>';

                htmlLi +=
                  '<li class="handleForYouTie" content="' +
                  dataD.contentId +
                  '">' +
                  '<div class="con lf">' +
                  '<p class="infosC lf actionNoMr">' +
                  conStrHtml +
                  "</p>" +
                  "</div>" +
                  '<div class="riCon lf">' +
                  '<p class="times lf">' +
                  "<span>" +
                  $(document).formatDate(dataD.createTime) +
                  "</span>" +
                  "</p>" +
                  '<p class="show_report">' +
                  '<span class="acknowledge"></span>' +
                  "</p>" +
                  "</div>" +
                  '<div style="clear: both;"></div>' +
                  "</li>";
              }
            }
          } else {
            if (dszP.status == "success") {
              window.open(_href);
            } else if (dszP.status == "suspend" || dszP.status == "ipsuspend") {
              //异常状态处理
              global_main.globalFn.callBackErrStatusOpreFn(dszP);
            } else {
              $(document).popErrorF({
                type: "open",
                tip: dszP.message,
              });
            }
          }
        },
      });
      return htmlLi;
    },
    //消息列表标题限制标题字数，中文展示15汉字，英文显示30汉字
    showTitleSize: function () {
      $(".js_NoticeList li")
        .find(".js_titleSize,.tieInfo a")
        .each(function () {
          var thisCon = $(this).text();
          var titleContentSub = "";
          for (var i = 0; i < thisCon.length; i++) {
            if (thisCon.charCodeAt(i) > 127 || thisCon.charCodeAt(i) == 94) {
              titleContentSub =
                thisCon.length > 15
                  ? $(this).text().substring(0, 15) + "..."
                  : $(this).text();
            } else {
              titleContentSub =
                thisCon.length > 30
                  ? $(this).text().substring(0, 30) + "..."
                  : $(this).text();
            }
          }
          $(this).text(titleContentSub);
        });
    },
    //策划展示内容
    getPlotter: function (dataD) {
      var htmlLi = "";
      var postType = dataD.contentType == "thread" ? "主帖" : "回帖";
      var plotterType =
        dataD.type == "plotter" ? "仅策划可见" : "取消仅策划可见";
      var conStr =
        '<span class="contentHidden">您的' +
        postType +
        "已被置成" +
        plotterType +
        '，如有疑问请<a target="_blank" class="linkePlotter" href="//kf.gyyx.cn/Home/IMIndex">联系客服</a>。</span>';
      htmlLi +=
        '<li class="handleForYouTie">' +
        '<div class="con lf">' +
        '<p class="infosC lf actionNoMr">' +
        conStr +
        "</p>" +
        "</div>" +
        '<div class="riCon lf">' +
        '<p class="times lf">' +
        "<span>" +
        $(document).formatDate(dataD.createTime) +
        "</span>" +
        "</p>" +
        '<p class="show_report">' +
        '<span class="acknowledge"></span>' +
        "</p>" +
        "</div>" +
        '<div style="clear: both;"></div>' +
        "</li>";

      return htmlLi;
    },
    //获取6级免费道具信息
    giftNameFun: function () {
      $.ajax({
        url: giftInfo,
        type: "GET",
        dataType: "json",
        data: {
          r: Math.random(),
          giftId: giftIcon,
        },
        success: function (d) {
          if (d.status == "success") {
            var giftName = d.data.giftName;
            $(".js_giftName").html(giftName);
          }
        },
      });
    },
    //我的列表--获取消息列表
    messageList: function (system) {
      var _thisMess = this;
      $(".js_NoticeList").ajaxPage({
        url: messageList,
        type: "POST",
        pageObj: $("#tieInfo_Table_0_paginate"),
        pageIndex: 1,
        pageSize: 15,
        curPageCls: "paginate_active",
        pageInfo: {
          obj: $("#tieInfo_Table_0_info"),
          content: "",
        },
        paramObj: {
          //传参
          type: system,
        },
        clickFn: function () {
          $(window).scrollTop(425);
        },
        dataFn: function (d) {
          var htmlAll = "";
          if (d.status == "success") {
            // 消息关闭
            if ($(".userInfo .icon2").hasClass("iconEmailHas")) {
              $(".myNews").fadeOut();
              $(".ovF .icon2").removeClass("iconEmailHas");
              $(".dynamicCenter .msgs .icoMN,.comingSoon").hide();
              global_main.globalFn.read();
            }
            //当前弹幕关闭
            if (!$(".myNews .msgAlert").is(":visible")) {
              clearTimeout(myNewsSet);
              //实时弹幕
              setTimeout(function () {
                global_main.globalFn.barrage();
              }, 1500);
            }
            var datas = d.data;
            if (datas && datas.length > 0) {
              $(".comingSoon").hide();
              $(".dataTables_wrapper,.js_NoticeList").show();

              for (var i = 0; i < datas.length; i++) {
                var dataD = datas[i];
                var isPlotter =
                  '<span class="ico_tie js_wealthsShow isPlotter"><span class="num js_marginLeft js_wealthNumTop" style="visibility: hidden; width: 60px; margin-left: -8px;">仅策划可见<i class="arrow"></i></span></span>';
                var isPlotterHtml = dataD.isPlotter ? isPlotter : "";
                switch (
                  dataD.type //type:消息类型
                ) {
                  case "replyComment": //回复评论
                  case "replyPost": //评论回帖
                  case "praiseComment": //点赞评论
                  case "hideComment": //隐藏评论
                    htmlAll += _thisMess.getCommentInfo(dataD, 1); //获取评论信息
                    continue;
                  case "plotter": //仅策划可见状态
                  case "cancelplotter": //取消仅策划可见状态
                    htmlAll += _thisMess.getPlotter(dataD);
                    continue;
                  case "runlottery": //竞猜开奖状态
                  case "stopQuiz": //终止竞猜
                  case "acceptAskHide": //求助帖采纳的回帖被隐藏或者删除
                  case "noticeAcceptAsk": //求助帖超过24小时未采纳回帖
                    htmlAll += _thisMess.getThreadInfo(dataD, 1);
                    continue;
                  case "replyThread": //回贴
                  case "praisePost": //点赞回帖
                  case "hidePost": //隐藏回贴
                  case "acceptAsk": //求助帖的回帖被采纳
                  case "collectPost": //收藏
                  case "acceptAskWithGW": //求助帖的回帖被采纳，赠与好心值
                    htmlAll += _thisMess.getPostInfo(dataD, 1); //获取回帖信息
                    continue;
                  //best、top、goldChest、silverChest、forbidden、removeForbidden、hideThread 不显示昵称
                  //content: 服务器端拼装返回
                  case "best": //精品贴
                  case "top": //置顶贴
                  case "goldchest": //金宝箱
                  case "silverchest": //银宝箱
                  case "forbidden": //禁言
                  case "removeForbidden": //解除禁言
                  case "hideThread": //隐藏主贴
                  case "changemodule": //移动帖子模块
                  case "suspend": //账号封停
                  case "ipsuspend": //ip封停
                  case "unBindRole": //社区解绑手机
                  case "modifyPassword": //修改密码
                  case "violatingAvatar": //违规头像
                  case "refuseApproval":
                    htmlAll +=
                      '<li class="handleForYouTie" content="' +
                      dataD.contentId +
                      '">' +
                      '<div class="con lf">' +
                      '<p class="infosC lf actionNoMr">' +
                      dataD.content +
                      "</p>" +
                      "</div>" +
                      '<div class="riCon lf">' +
                      '<p class="times lf">' +
                      "<span>" +
                      $(document).formatDate(dataD.createTime) +
                      "</span>" +
                      "</p>" +
                      '<p class="show_report">' +
                      '<span class="acknowledge"></span>' +
                      "</p>" +
                      "</div>" +
                      '<div style="clear: both;"></div>' +
                      "</li>";
                    continue;
                  case "exchangeYinFu": //银符钱兑换
                  case "rechargeJinFu": //金符钱充值时
                    htmlAll +=
                      '<li class="handleForYouTie" content="' +
                      dataD.contentId +
                      '">' +
                      '<div class="con lf">' +
                      '<p class="liftBan">' +
                      dataD.content +
                      "</p>" +
                      "</div>" +
                      '<div class="riCon lf">' +
                      '<p class="times lf">' +
                      "<span>" +
                      $(document).formatDate(dataD.createTime) +
                      "</span>" +
                      "</p>" +
                      '<p class="show_report">' +
                      '<span class="acknowledge"></span>' +
                      "</p>" +
                      "</div>" +
                      '<div style="clear: both;"></div>' +
                      "</li>";
                    continue;

                  //praiseThread、gift、关注  显示昵称
                  case "praiseThread": //点赞主贴
                  case "sliver": //送银元宝和撤销
                  case "gift": //送礼
                  case "inviteAnswer": //邀请
                  case "follow": //关注
                    htmlAll +=
                      '<li class="handleForYouTie" content="' +
                      dataD.contentId +
                      '">' +
                      '<div class="con lf">' +
                      '<p class="infosC lf">' +
                      '<a target="_blank" href="/user?id=' +
                      dataD.fromId +
                      '">' +
                      '<span class="sourceNick js_checkEveryUserInfo" data-userinfoid="' +
                      dataD.fromId +
                      '">' +
                      dataD.fromNickname +
                      "</span>" +
                      "</a>" +
                      dataD.content +
                      isPlotterHtml +
                      "</p>" +
                      "</div>" +
                      '<div class="riCon lf">' +
                      '<p class="times lf">' +
                      "<span>" +
                      $(document).formatDate(dataD.createTime) +
                      "</span>" +
                      "</p>" +
                      '<p class="show_report">' +
                      '<span class="acknowledge"></span>' +
                      "</p>" +
                      "</div>" +
                      '<div style="clear: both;"></div>' +
                      "</li>";
                    continue;
                  case "daojieMessage": //道姐发消息
                    htmlAll +=
                      '<li class="handleForYouTie daojieMess" content="' +
                      dataD.contentId +
                      '" >' +
                      '<div class="con lf">' +
                      '<p class="infosC lf">' +
                      '<a class="daojieLink">' +
                      '<span class="sourceNick lf" data-userinfoid="' +
                      dataD.fromId +
                      '">道姐</span>' +
                      '<span class="actionTo">说 :</span>' +
                      "</a>" +
                      '<span class="messageDojie">' +
                      dataD.content +
                      "</span>" +
                      "</p>" +
                      "</div>" +
                      '<div class="riCon lf">' +
                      '<p class="times lf">' +
                      "<span>" +
                      $(document).formatDate(dataD.createTime) +
                      "</span>" +
                      "</p>" +
                      '<p class="show_report">' +
                      '<span class="acknowledge"></span>' +
                      "</p>" +
                      "</div>" +
                      '<div style="clear: both;"></div>' +
                      "</li>";
                    continue;
                  case "rewardLikeThread":
                  case "postRewardThread":
                  case "rewardStatistics":
                    htmlAll +=
                      '<li class="handleForYouTie daojieMess" content="' +
                      dataD.contentId +
                      '" >' +
                      '<div class="con lf">' +
                      '<p class="infosC lf">' +
                      // '<a class="daojieLink">'+
                      // 	'<span class="sourceNick lf" data-userinfoid="'+dataD.fromId+'">道姐</span>'+
                      // 	'<span class="actionTo">说 :</span>'+
                      // '</a>'+
                      '<span class="messageDojie" style="overflow: inherit;">' +
                      dataD.content +
                      "</span>" +
                      "</p>" +
                      "</div>" +
                      '<div class="riCon lf">' +
                      '<p class="times lf">' +
                      "<span>" +
                      $(document).formatDate(dataD.createTime) +
                      "</span>" +
                      "</p>" +
                      '<p class="show_report">' +
                      '<span class="acknowledge"></span>' +
                      "</p>" +
                      "</div>" +
                      '<div style="clear: both;"></div>' +
                      "</li>";
                    continue;
                  case "reportHandle": //您的举报已经处理
                    htmlAll +=
                      '<li class="handleForYouTie" content="' +
                      dataD.contentId +
                      '" >' +
                      '<div class="con lf">' +
                      '<p class="infosC lf">' +
                      '<span class="reportYes" style="color:#989898">' +
                      dataD.content +
                      "</span>" +
                      "</p>" +
                      "</div>" +
                      '<div class="riCon lf">' +
                      '<p class="times lf">' +
                      "<span>" +
                      $(document).formatDate(dataD.createTime) +
                      "</span>" +
                      "</p>" +
                      '<p class="show_report">' +
                      '<span class="acknowledge"></span>' +
                      "</p>" +
                      "</div>" +
                      '<div style="clear: both;"></div>' +
                      "</li>";
                    continue;
                  case "levelUp": //用户升级
                    //截取字符串
                    var contentLevel = dataD.content;
                    var contentLevelArr = contentLevel.split(",");
                    var levelMessage = contentLevelArr[0]; //用户等级
                    var badge = contentLevelArr[1]; //特殊标识
                    if (badge == "badge" && levelMessage == "5") {
                      htmlAll +=
                        '<li class="handleForYouTie" content="' +
                        dataD.contentId +
                        '">' +
                        '<div class="con lf">' +
                        '<p class="infosC lf">' +
                        '<span class="contentHidden">恭喜您升级到' +
                        levelMessage +
                        "级，道姐送您一个等级徽章</span>" +
                        "</p>" +
                        "</div>" +
                        '<div class="riCon lf">' +
                        '<p class="times lf">' +
                        "<span>" +
                        $(document).formatDate(dataD.createTime) +
                        "</span>" +
                        "</p>" +
                        '<p class="show_report">' +
                        '<span class="acknowledge"></span>' +
                        "</p>" +
                        "</div>" +
                        '<div style="clear: both;"></div>' +
                        "</li>";
                    } else if (badge == "gift" && levelMessage == "6") {
                      //6级获得免费道具
                      giftIcon = contentLevelArr[2]; //6级免费道具
                      htmlAll +=
                        '<li class="handleForYouTie" content="' +
                        dataD.contentId +
                        '">' +
                        '<div class="con lf">' +
                        '<p class="infosC lf">' +
                        '<span class="contentHidden">恭喜您升级到' +
                        levelMessage +
                        '级，获得论坛免费道具-<b class="js_giftName" style="color: #2b7acd;"></b></span>' +
                        "</p>" +
                        "</div>" +
                        '<div class="riCon lf">' +
                        '<p class="times lf">' +
                        "<span>" +
                        $(document).formatDate(dataD.createTime) +
                        "</span>" +
                        "</p>" +
                        '<p class="show_report">' +
                        '<span class="acknowledge"></span>' +
                        "</p>" +
                        "</div>" +
                        '<div style="clear: both;"></div>' +
                        "</li>";
                    } else if (badge == "avatarIcon" && levelMessage == "8") {
                      //8级获得头像框
                      htmlAll +=
                        '<li class="handleForYouTie" content="' +
                        dataD.contentId +
                        '">' +
                        '<div class="con lf">' +
                        '<p class="infosC lf">' +
                        '<span class="contentHidden">恭喜您升级到' +
                        levelMessage +
                        "级，获得头像框</span>" +
                        "</p>" +
                        "</div>" +
                        '<div class="riCon lf">' +
                        '<p class="times lf">' +
                        "<span>" +
                        $(document).formatDate(dataD.createTime) +
                        "</span>" +
                        "</p>" +
                        '<p class="show_report">' +
                        '<span class="acknowledge"></span>' +
                        "</p>" +
                        "</div>" +
                        '<div style="clear: both;"></div>' +
                        "</li>";
                    } else if (badge == "rename" && levelMessage == "10") {
                      //10级获得改昵称机会
                      htmlAll +=
                        '<li class="handleForYouTie" content="' +
                        dataD.contentId +
                        '">' +
                        '<div class="con lf">' +
                        '<p class="infosC lf">' +
                        '<span class="contentHidden">恭喜您升级到' +
                        levelMessage +
                        "级，获得一次改名机会</span>" +
                        "</p>" +
                        "</div>" +
                        '<div class="riCon lf">' +
                        '<p class="times lf">' +
                        "<span>" +
                        $(document).formatDate(dataD.createTime) +
                        "</span>" +
                        "</p>" +
                        '<p class="show_report">' +
                        '<span class="acknowledge"></span>' +
                        "</p>" +
                        "</div>" +
                        '<div style="clear: both;"></div>' +
                        "</li>";
                    } else if (badge == "5PercentOff" && levelMessage == "12") {
                      //12级获得折扣卡
                      htmlAll +=
                        '<li class="handleForYouTie" content="' +
                        dataD.contentId +
                        '">' +
                        '<div class="con lf">' +
                        '<p class="infosC lf">' +
                        '<span class="contentHidden">恭喜您升级到' +
                        levelMessage +
                        "级，获得95折折扣卡</span>" +
                        "</p>" +
                        "</div>" +
                        '<div class="riCon lf">' +
                        '<p class="times lf">' +
                        "<span>" +
                        $(document).formatDate(dataD.createTime) +
                        "</span>" +
                        "</p>" +
                        '<p class="show_report">' +
                        '<span class="acknowledge"></span>' +
                        "</p>" +
                        "</div>" +
                        '<div style="clear: both;"></div>' +
                        "</li>";
                    } else if (
                      badge == "10PercentOff" &&
                      levelMessage == "15"
                    ) {
                      //15级获得折扣卡
                      htmlAll +=
                        '<li class="handleForYouTie" content="' +
                        dataD.contentId +
                        '">' +
                        '<div class="con lf">' +
                        '<p class="infosC lf">' +
                        '<span class="contentHidden">恭喜您升级到' +
                        levelMessage +
                        "级，获得9折折扣卡</span>" +
                        "</p>" +
                        "</div>" +
                        '<div class="riCon lf">' +
                        '<p class="times lf">' +
                        "<span>" +
                        $(document).formatDate(dataD.createTime) +
                        "</span>" +
                        "</p>" +
                        '<p class="show_report">' +
                        '<span class="acknowledge"></span>' +
                        "</p>" +
                        "</div>" +
                        '<div style="clear: both;"></div>' +
                        "</li>";
                    } else {
                      htmlAll +=
                        '<li class="handleForYouTie" content="' +
                        dataD.contentId +
                        '">' +
                        '<div class="con lf">' +
                        '<p class="infosC lf">' +
                        '<span class="contentHidden">恭喜您升级到' +
                        levelMessage +
                        "级</span>" +
                        "</p>" +
                        "</div>" +
                        '<div class="riCon lf">' +
                        '<p class="times lf">' +
                        "<span>" +
                        $(document).formatDate(dataD.createTime) +
                        "</span>" +
                        "</p>" +
                        '<p class="show_report">' +
                        '<span class="acknowledge"></span>' +
                        "</p>" +
                        "</div>" +
                        '<div style="clear: both;"></div>' +
                        "</li>";
                    }
                }
              }
            } else {
              $(".pageCut,.js_NoticeList").hide();
              if (system === "receiveGoods") {
                $(".comingSoon")
                  .html("您还未获得任何物品哟~")
                  .css("display", "block");
              } else {
                $(".comingSoon").html("暂无消息").css("display", "block");
              }
            }
          }
          //未登录异常处理
          $(document).errorDataOperateFn(d, null, {
            loginErrorFn: function () {
              //异常
              $(".pageCut,.js_NoticeList").hide();
              $(".comingSoon")
                .html("您暂无登录，请先登录")
                .css("display", "block");
            },
          });
          $(".typeMsg").attr("repeat", "yes");
          return htmlAll;
        },
        successFn: function () {
          $(".isPlotter").hoverAnimateFn(".js_wealthNumTop"); //仅策划显示显示
          _thisMess.showTitleSize();
          _thisMess.giftNameFun(); //道具名称
        },
      });
    },
  };

  window.DaoMessageUser = DaoMessageUser;
})();
$(function () {
  var daoMessageUser = new DaoMessageUser();
  daoMessageUser.init();
});
